// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import axios from "axios";
import ElementUI from "element-ui";
import XLSX from "xlsx";
import ElTreeSelect from "el-tree-select";
Vue.use(ElTreeSelect);
Vue.use(XLSX);
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);
// 地图转换

import "./assets/css/react.css";
import "./assets/js/common.js";
import store from "@/store/store.js";
import { ApiUrl, homeApiHr, load,LoginApiUrl,UserUrl } from "./assets/js/api.js";

import CustomComponent from "./components/CustomComponent/index.js";
// 二维码
import VueQriously from 'vue-qriously';

Vue.use(CustomComponent);
Vue.use(VueQriously)

Vue.prototype.$axios = axios;
Vue.prototype.ApiUrl = ApiUrl;
Vue.prototype.$load = load;
Vue.config.productionTip = false;
axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    localStorage.removeItem("pcToken");
    if (error.response) {
      console.log('进来了', error.response);
      // 处理不同的错误状态码
      switch (error.response.status) {
        case 401:
        case 402:
        case 403:
          console.log('身份验证失效，请重新登录');
          top.location.href = homeApiHr;
          break;
        case 405:
          console.log('数据出错', error);
          break;
        default:
          console.log('未知错误', error);
      }
    } else {
      // 如果没有响应数据（如网络断开）
      console.log('网络错误或服务器无响应', error);
    }
    return Promise.reject(error.response.data); // 返回接口返回的错误信息
  }
);

/* 路由发生变化 */
router.beforeEach((to, from, next) => {
  next();
})

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  render: h => h(App)
});


// 弹框提示
Vue.prototype.messageTipWord = function(
  message = "请重新填写",
  type = "error",
  showClose = true,
  center = true,
  onClose = true
) {
  this.$message({
    message,
    type,
    showClose,
    center,
    onClose
  });
};
// 双击事件
Vue.directive("preventReClick", {
  inserted(el, binding) {
    el.addEventListener("click", () => {
      if (!el.disabled) {
        el.disabled = true;
        setTimeout(() => {
          el.disabled = false;
        }, binding.value || 2000);
      }
    });
  }
});
// 放重点-自定义组件
Vue.directive("preventCustomReClick", {
  inserted(el, binding) {
    el.addEventListener(
      "click",
      e => {
        if (!el.disabled) {
          el.disabled = true;
          setTimeout(() => {
            el.disabled = false;
          }, binding.value || 2000);
        } else {
          // disabled为true时，阻止默认的@click事件
          e.preventDefault();
          e.stopPropagation();
        }
      },
      true
    );
  }
});
Vue.directive("allnum", {
  ruleName(el, binding) {
    el.addEventListener("change", () => {
      console.log(1);
    });
  }
});
// 删除空格字符串
Vue.prototype.delSpace = function(pamas) {
  console.log(1112);
  return pamas.replace(/\s+/g, "");
};
// 判断手机号
Vue.prototype.testPhone = function(phone) {
  var _this = this;
  console.log(1112);
  if (!/^1[3456789]\d{9}$/.test(phone)) {
    _this.message({
      message: "请输入正确手机号",
      type: "error"
    });
  }
  return;
};

Vue.prototype.progressNum = 20;



// WEBPACK FOOTER //
// ./src/main.js